import { ROUTES } from 'app/core/router/paths';

/**
 * @description 流程步驟代碼
 */
export enum ProcessStepCodesEnum {
  /** 確認資料 (Step-1-1) */
  ConfirmInfo = '1-1',
  /** 確認資料 (Step-1-2) */
  ConfirmInfoOTPAuth = '1-2',
  /** 線上繳費/繳費方式 (Step-2-1) */
  Payment = '2-1',
  /** 線上繳費/帳戶轉帳 (Step-2-2) */
  PaymentTransfer = '2-2',
  /** 線上繳費/信用卡 (Step-2-2) */
  PaymentCreditCard = '2-2',
  /** 繳費完成、繳費失敗 (Step-3) */
  Result = '3-1'
}

/**
 * @description 流程步驟文字
 */
export enum ProcessStepTextEnum {
  /** 確認資料 (Step-1-1) */
  ConfirmInfo = '確認資料',
  /** 確認資料 (Step-1-2) */
  ConfirmInfoOTPAuth = '確認資料',
  /** 線上繳費/繳費方式 (Step-2-1) */
  Payment = '線上繳費',
  /** 繳費完成、繳費失敗 (Step-3) */
  Result = '繳費完成、繳費失敗'
}

/**
 * @description 流程路由對應步驟代碼
 */
export const ProcessRouteMatchesStep: Readonly<Record<string, ProcessStepCodesEnum>> = {
  /** 確認資料 (Step-1-1) */
  [ROUTES.SERVICE__QUERY_POLICY__PAY__CONFIRM_INFO]: ProcessStepCodesEnum.ConfirmInfo,
  /** 確認資料 (Step-1-2) */
  [ROUTES.SERVICE__QUERY_POLICY__PAY__CONFIRM_INFO__OTP_AUTH]: ProcessStepCodesEnum.ConfirmInfoOTPAuth,
  /** 線上繳費/繳費方式 (Step-2-1) */
  [ROUTES.SERVICE__QUERY_POLICY__PAY__PAYMENT]: ProcessStepCodesEnum.Payment,
  /** 線上繳費/帳戶轉帳 (Step-2-2) */
  [ROUTES.SERVICE__QUERY_POLICY__PAY__PAYMENT__TRANSFER]: ProcessStepCodesEnum.PaymentTransfer,
  /** 線上繳費/信用卡 (Step-2-2) */
  [ROUTES.SERVICE__QUERY_POLICY__PAY__PAYMENT__CREDIT_CARD]: ProcessStepCodesEnum.PaymentCreditCard,
  /** 繳費完成、繳費失敗 (Step-3) */
  [ROUTES.SERVICE__QUERY_POLICY__PAY__RESULT]: ProcessStepCodesEnum.Result
};

/**
 * @description 流程步驟代碼對應路由
 */
export const ProcessStepMatchesRoute: Readonly<Record<ProcessStepCodesEnum, string>> = {
  /** 確認資料 (Step-1-1) */
  [ProcessStepCodesEnum.ConfirmInfo]: ROUTES.SERVICE__QUERY_POLICY__PAY__CONFIRM_INFO,
  /** 確認資料 (Step-1-1) */
  [ProcessStepCodesEnum.ConfirmInfoOTPAuth]: ROUTES.SERVICE__QUERY_POLICY__PAY__CONFIRM_INFO__OTP_AUTH,
  /** 線上繳費/繳費方式 (Step-2-1) */
  [ProcessStepCodesEnum.Payment]: ROUTES.SERVICE__QUERY_POLICY__PAY__PAYMENT,
  /** 線上繳費/信用卡 (Step-2-2) */
  [ProcessStepCodesEnum.PaymentCreditCard]: ROUTES.SERVICE__QUERY_POLICY__PAY__PAYMENT__CREDIT_CARD,
  /** 線上繳費/帳戶轉帳 (Step-2-2) */
  [ProcessStepCodesEnum.PaymentTransfer]: ROUTES.SERVICE__QUERY_POLICY__PAY__PAYMENT__TRANSFER,
  /** 繳費完成、繳費失敗 (Step-3) */
  [ProcessStepCodesEnum.Result]: ROUTES.SERVICE__QUERY_POLICY__PAY__RESULT
};
